/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Tags from "./Tags";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class SessionTagPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		this.getValues();
	}

	getValues = () => {
		GetItem(`/apps/${this.appKey}/sessions`).then(data => {
			let values = [];
			let tags = {};
			data.data.forEach(item => {
				item.tags.forEach(tag => {
					tags[tag] = tag;
				});
			});
			Object.keys(tags).forEach(tag => {
				values.push({
					id: tag,
					label: tag,
				});
			});

			this.setState({ values });
		});
	};

	render() {
		return (
			<div className="picker-input">
				{this.state.values && (
					<Tags
						{...this.props}
						dataObjects={this.state.values}
						dataObjectKey="id"
						dataObjectLabel="label"
						minQueryLength={1}
					/>
				)}
			</div>
		);
	}
}

SessionTagPicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	apps: PropTypes.array,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
});

export default connect(mapStateToProps)(SessionTagPicker);
